<template>
  <div class="team-values-screen">
    <div class="team-values-screen__content container">
      <ScreenHeader class="team-values-screen__header" data-aos="fade-down">
        <template #subtitle>{{
          headerSubtitle || TEAM_VALUES_SCREEN_DEFAULTS.headerSubtitle
        }}</template>
        <template #title>{{
          headerTitle || TEAM_VALUES_SCREEN_DEFAULTS.headerTitle
        }}</template>
        <template #text>
          {{
            headerText ||
            "These principles guide us in every project and help us create experiences that players love."
          }}
        </template>
      </ScreenHeader>
      <div class="team-values-screen__values">
        <div
          class="team-value team-values-screen__value"
          v-for="(value, i) in values"
          :key="value.id"
          data-aos="fade-up"
          :style="{
            backgroundImage: `${gradients[i % gradients.length]}, url(${
              value.backgroundUri
            })`,
          }"
        >
          <i class="team-value__icon fa-solid" :class="[value.icon]" />
          <div class="team-value__content">
            <p class="team-value__title">{{ value.title }}</p>
            <p class="team-value__description">{{ value.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const TEAM_VALUES_SCREEN_DEFAULTS = {
    headerSubtitle: "What We Believe In",
    headerTitle: "Values That Drive Us",
    headerText: "These principles guide us in every project and help us create experiences that players love.",
  }

  const props = defineProps<{
    headerSubtitle?: string;
    headerTitle?: string;
    headerText?: string;
    values: { id: number; title: string; description: string; icon: string; backgroundUri: string }[];
  }>();

  const gradients = [
    "linear-gradient(126deg, #145ec5CC 0%, #723738CC 100%)",
    "linear-gradient(126deg, #9c7711CC 0%, #723772CC 100%)",
    "linear-gradient(126deg, #c83e3eCC 0%, #373f72CC 100%)",
    "linear-gradient(126deg, #6129b3CC 0%, #060e2aCC 100%)",
  ];
</script>

<style lang="scss">
  .team-values-screen {
    &__content {
      display: flex;
      flex-direction: column;
      gap: 32px;

      padding: 64px 16px;

      @media (max-width: $md) {
        gap: 16px;
      }
    }

    &__values {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }

  .team-value {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;

    padding: 64px;

    border-radius: 16px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    color: white;

    @media (max-width: $md) {
      flex-direction: column;
      text-align: center;
      padding: 64px 32px;
    }

    &__content {
      display: flex;
      flex-direction: column;
      gap: 8px;

      @media (max-width: $md) {
        gap: 24px;
      }
    }

    &__icon {
      font-size: 96px;
    }

    &__title {
      font-weight: 700;
      font-size: 36px;
      line-height: 100%;
      color: #fff;
    }

    &__description {
      max-width: 700px;

      font-weight: 600;
      font-size: 16px;
      line-height: 137%;
      color: #fff;
    }
  }
</style>
